import React from 'react'

const Layout = ({children }) => (
    <div style={{backgroundColor:'white' , borderRadius:'16px' , padding:'0px 24px'}} className='data-container'>
       {children }
    </div>
   );

export default Layout
